let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("9zLwF"), load("cE2He")]).then(() => parcelRequire('8be30'));